module.exports = __webpack_public_path__ + "img/colheita.78aac073.png";